module.exports = __webpack_public_path__ + "static/media/CTV.e99f07bb.png";